import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FamilyTree from '../components/FamilyTree';
import AddMemberForm from '../components/AddMemberForm';
import RequestManager from '../components/RequestManager';

const AdminPage = () => {
  const [members, setMembers] = useState([]);
  const [activeTab, setActiveTab] = useState('tree'); // 'tree' | 'requests'
  
  // MODAL STATE
  const [showForm, setShowForm] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null);
  const [formMode, setFormMode] = useState('child'); 
  const [editingMember, setEditingMember] = useState(null);

  // 1. FETCHING
  const fetchMembers = async () => {
    try {
      const res = await axios.get('/api/family-members?email=shripadkhadilkar@gmail.com');
      setMembers(res.data);
    } catch (err) { console.error("Error fetching members:", err); }
  };

  useEffect(() => {
    fetchMembers();
  }, [activeTab]);

  // --- Handlers ---
  const handleAddMember = (node, mode) => {
    setSelectedNode(node);
    setFormMode(mode || 'child');
    setEditingMember(null);
    setShowForm(true); 
  };

  const handleEditMember = (member) => {
    setSelectedNode(null);
    setFormMode('edit');
    setEditingMember(member); 
    setShowForm(true); 
  };

  const handleDeleteMember = async (id) => {
    if (window.confirm('Are you sure you want to delete this member?')) {
      try {
        await axios.delete(`/api/admin/members/${id}`);
        fetchMembers();
      } catch (err) { 
          console.error("Delete Error", err);
          alert('Failed to delete member'); 
      }
    }
  };

  const handleFormSubmit = async (data) => {
    try {
      if (editingMember) {
        await axios.put(`/api/admin/members/${editingMember.id}`, data);
      } else {
        await axios.post('/api/admin/members', data);
      }
      setShowForm(false);
      fetchMembers();
    } catch (err) {
      console.error(err);
      alert('Error saving member: ' + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-64px)] font-sans text-slate-900 bg-slate-100">
      
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <aside className="w-64 bg-white shadow-xl z-10 hidden md:flex flex-col border-r border-slate-200">
            <div className="p-6 border-b border-slate-100 bg-slate-50">
                <h2 className="text-xl font-bold text-slate-800">Admin Dashboard</h2>
            </div>
            <nav className="flex-1 p-4 space-y-2">
                <button onClick={() => setActiveTab('tree')} className={`w-full text-left px-4 py-3 rounded-lg font-semibold transition flex items-center gap-3 ${activeTab === 'tree' ? 'bg-blue-600 text-white shadow-md' : 'text-slate-600 hover:bg-slate-100'}`}>
                   <span>🌳</span> Family Tree
                </button>
                <button onClick={() => setActiveTab('requests')} className={`w-full text-left px-4 py-3 rounded-lg font-semibold transition flex items-center gap-3 ${activeTab === 'requests' ? 'bg-blue-600 text-white shadow-md' : 'text-slate-600 hover:bg-slate-100'}`}>
                   <span>📋</span> Requests
                </button>
            </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 overflow-auto relative bg-slate-100 p-0">
            {activeTab === 'tree' && (
                <div className="h-full w-full overflow-auto">
                   <FamilyTree 
                      members={members} 
                      onAddMember={handleAddMember}
                      onEditMember={handleEditMember}
                      onDeleteMember={handleDeleteMember}
                      isAdmin={true}
                   />
                </div>
            )}
            
            {activeTab === 'requests' && (
                <div className="p-8 max-w-5xl mx-auto">
                    <h2 className="text-2xl font-bold mb-6 text-slate-800">Manage Access Requests</h2>
                    <RequestManager onUpdate={fetchMembers} />
                </div>
            )}
        </main>
      </div>

      {/* POPUP FORM */}
      {showForm && (
        <AddMemberForm 
          onSubmit={handleFormSubmit} 
          onClose={() => setShowForm(false)} 
          selectedNode={selectedNode}
          formMode={formMode}
          initialData={editingMember}
        />
      )}
    </div>
  );
};

export default AdminPage;